import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { PUBLIC_URL } from "../config";
import activeDiscount from "../helpers/activeDiscount";
import calculatePrice from "../helpers/calculatePrice";

export default class CartItem extends Component {
  state = { remove: false, delete: false };

  render() {
    const discount = activeDiscount(this.props.product.categories);

    return (
      <tr
        className={this.state.remove ? `cart-item remove` : "cart-item"}
        style={
          !this.state.remove
            ? {
                transform: "none",
                transition: "none",
              }
            : {}
        }
      >
        <td className="product-thumb text-center">
          <Link
            to={{
              pathname: `/urun/${this.props.product.slug}`,
              state: { product: this.props.product },
            }}
          >
            <img
              alt={this.props.product.name}
              src={this.props.product.images && this.props.product.images[0] 
                ? `${PUBLIC_URL}/uploads/${this.props.product.images[0]}`
                : this.props.product.image 
                  ? PUBLIC_URL(this.props.product.image)
                  : '/images/placeholder.jpg'
              }
              className="img-fluid rounded"
              style={{ 
                maxWidth: '80px', 
                maxHeight: '80px', 
                objectFit: 'cover',
                border: '1px solid #e9ecef'
              }}
            />
          </Link>
        </td>
        <td className="product-name">
          <Link
            to={{
              pathname: `/urun/${this.props.product.slug}`,
              state: { product: this.props.product },
            }}
          >
            {this.props.product.name}
          </Link>
        </td>
        <td className="text-center">
          <span
            style={{
              color: discount ? "#ccc" : "#000",
              textDecoration: discount ? "line-through" : "none",
            }}
          >
            ₺
            {this.props.product.sale_price
              ? parseFloat(this.props.product.sale_price).toFixed(2)
              : parseFloat(this.props.product.price).toFixed(2)}
          </span>
          {discount ? (
            <React.Fragment>
              <br />
              <span className="text-success fw-bold">
                ₺
                {discount.type === "percent"
                  ? this.props.product.sale_price
                    ? parseFloat(
                        this.props.product.sale_price *
                          (1 - discount.discount / 100)
                      ).toFixed(2)
                    : parseFloat(
                        this.props.product.price * (1 - discount.discount / 100)
                      ).toFixed(2)
                  : this.props.product.sale_price
                  ? parseFloat(
                      this.props.product.sale_price - discount.discount
                    ).toFixed(2)
                  : parseFloat(
                      this.props.product.price - discount.discount
                    ).toFixed(2)}
              </span>
            </React.Fragment>
          ) : null}
        </td>
        <td className="product-quantity text-center">
          <div className="input-group" style={{ maxWidth: '140px', margin: '0 auto' }}>
            <button
              className="btn btn-outline-secondary btn-sm"
              type="button"
              disabled={this.props.product.quantity === 1}
              onClick={(e) => {
                e.preventDefault();
                this.props.decCart();
              }}
              style={{ borderColor: '#dee2e6' }}
            >
              <FontAwesomeIcon icon={["fas", "minus"]} />
            </button>
            <input
              type="number"
              className="form-control form-control-sm text-center"
              value={this.props.product.quantity}
              onChange={(e) => {
                let value = e.target.value;
                if (value === "") value = "1";
                value = value.replace(/[^0-9]+/g, "");
                if (value < 1) value = 1;
                this.props.updateCartQuantity(parseInt(value));
              }}
              min="1"
              style={{ 
                borderLeft: 'none', 
                borderRight: 'none',
                maxWidth: '50px'
              }}
            />
            <button
              className="btn btn-outline-secondary btn-sm"
              type="button"
              onClick={(e) => {
                e.preventDefault();
                this.props.incCart();
              }}
              style={{ borderColor: '#dee2e6' }}
            >
              <FontAwesomeIcon icon={["fas", "plus"]} />
            </button>
          </div>
          <small className="text-muted d-block mt-1">Adet</small>
        </td>
        <td className="text-center fw-bold">₺{calculatePrice(this.props.product, discount)}</td>
        <td className="product-status text-center">
          <button
            className="btn btn-link text-danger p-1"
            title="Sepetten Kaldır"
            onClick={(e) => {
              e.preventDefault();
              if (
                window.confirm(
                  `${this.props.product.name} ürününü sepetinizden çıkartmak istediğinize eminmisiniz?`
                )
              ) {
                this.setState({ remove: true }, () => {
                  setTimeout(() => {
                    this.props.removeCart();
                    this.setState({ remove: false });
                  }, 500);
                });
              }
            }}
          >
            <FontAwesomeIcon icon={["fas", "times"]} />
          </button>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CartItem.js